/**
 * @file 登录模块
 * @author congpeisen@baidu.com
 */

/* global getCurrentPages swan */
import * as core from './core';

/**
 * 跳转登录页
 * @param {Object} userConf 用户配置，详见：http://wiki.baidu.com/pages/viewpage.action?pageId=537399885
 * @param {number} userConf.type        登录类型：1-账号密码；2-手机号验证码(H5使用)
 * @param {number} userConf.params      统计参数（H5使用）
 * @param {number} userConf.href        登录成功后跳转地址（通用）
 * @param {number} userConf.openType    登录成功后跳转页面方式（swan使用）
 * @param {number} userConf.isReplaceUrl 进入登录页是否replaceState（H5使用）
 */
export const toLoginPage = (userConf = {}) => {
  {
    const conf = core.extend({
      type: 1,
      params: {
        src: 'se_020003',
        from: 'common'
      },
      href: '',
      isReplaceUrl: false
    }, userConf);
    const query = core.extend({
      tpl: 'wise',
      extrajson: JSON.stringify(conf.params),
      u: conf.href ? encodeURIComponent(window.location.origin + conf.href) : encodeURIComponent(window.location.href)
    }, conf.type === 2 ? {
      sms: 1
    } : {});
    const url = 'https://wappass.baidu.com' + '?' + core.getQueryStr(query);
    if (conf.isReplaceUrl) {
      window.location.replace(url);
    } else {
      window.location.href = url;
    }
  }
};